const prefix_local = 'avn'

const persistentData = {
  setData(property, value, json) {
    if (json) value = JSON.stringify(value)
    localStorage.setItem(`${prefix_local}-${property}`, value)
  },
  getData(property, json) {
    if (json) return JSON.parse(localStorage.getItem(`${prefix_local}-${property}`))
    return localStorage.getItem(`${prefix_local}-${property}`)
  },
  removeData(property) {
    localStorage.removeItem(`${prefix_local}-${property}`)
  },
  signOut() {
    localStorage.removeItem(`${prefix_local}-jwtToken`)
  }
}

export default persistentData;